export function splitBrandWordmark(name: string): { brandName: string; tld: string } {
  const dotLvIndex = name.toLowerCase().lastIndexOf('.lv');
  if (dotLvIndex > 0) {
    return { brandName: name.slice(0, dotLvIndex), tld: name.slice(dotLvIndex) };
  }

  const camelIndex = name.search(/[A-Z][a-zA-Z]*$/);
  if (camelIndex > 0) {
    return { brandName: name.slice(0, camelIndex), tld: name.slice(camelIndex) };
  }

  return { brandName: name, tld: '' };
}
